/**
 * Created with IntelliJ IDEA.
 * User: talf
 * Date: 9/9/13
 * Time: 3:46 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {

    window.lpTag = window.lpTag || {};

    var lpUtils = require('utils/lpUtils');
    var ShortcutPopupViewController = require('web-agent-viewControllers/ShortcutPopupViewController');

    var PreDefinedShortcutPopup = ShortcutPopupViewController.extend({
        ControllerName: 'PreDefinedShortcutPopup',

        initialize: function (constructorData) {
            this.managerContext = constructorData.context;
            this.notifyHide = constructorData.notifyHide;
        },

        events: function () {
            this.bindViewEvent({view : this.view, callback : this.checkFocusChanged, DOMEvent : "mousedown"});
        },

        render: function () {
            this.getFirstElement(this.LPViewMap.mainElement).tabIndex = 1; // this is done so the popup will get focus events
        }
    });

    PreDefinedShortcutPopup.prototype.updatePopupData = function (data) {
        this.updateModelData(data.shortcutInfo.modelData);
        this.updateVisitorData(data.visitorInfo);
    };

    PreDefinedShortcutPopup.prototype.updateVisitorData = function (visitorInfo) {
        if (visitorInfo && visitorInfo.visitorId && visitorInfo.targetView && visitorInfo.focusedView) {
            this.updatePopupView(visitorInfo);
            this.updateFocusedView(visitorInfo);
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorInfo.visitorId);
            this.bindModel({modelPath : participantPath + '.participantTag', callback : this.updateParticipantTag});
            this.latestVisitorInfo = visitorInfo;
        }
    };

    PreDefinedShortcutPopup.prototype.updateParticipantTag = function (data) {
        if (!data.newValue) {
            return;
        }
        if (this.colorTag) {
            this.removeClass(this.LPViewMap.mainElement, this.colorTag);
        }
        this.colorTag = data.newValue;
        this.addClass(this.LPViewMap.mainElement, this.colorTag);
    };

    PreDefinedShortcutPopup.prototype.updatePopupView = function (visitorInfo) {
        if (this.latestVisitorInfo) {
            this.view.parentElement.removeChild(this.view);
            this.viewEventsHandler.unbindEvent({appName : this.latestVisitorInfo.visitorId, callback : this.checkFocusChanged, UIEvent : this.viewEventsHandler.eventType.VISITOR_BLURRED});
            this.viewEventsHandler.unbindEvent({appName : this.latestVisitorInfo.visitorId, callback : this.visitorDisposed, UIEvent : this.viewEventsHandler.eventType.VISITOR_DISPOSED});
        }
        if (visitorInfo) {
            visitorInfo.targetView.appendChild(this.view); // update to new targetView
            this.viewEventsHandler.bindEvent({appName : visitorInfo.visitorId, callback : this.checkFocusChanged, UIEvent : this.viewEventsHandler.eventType.VISITOR_BLURRED});
            this.viewEventsHandler.bindEvent({appName : visitorInfo.visitorId, callback : this.visitorDisposed, UIEvent : this.viewEventsHandler.eventType.VISITOR_DISPOSED});
        }
    };

    PreDefinedShortcutPopup.prototype.visitorDisposed = function () {
        this.dispose();
    };

    PreDefinedShortcutPopup.prototype.updateFocusedView = function (visitorInfo) {
        if (this.latestVisitorInfo) {
            //this.unbindViewEvent({view : this.latestVisitorInfo.focusedView, callback : this.checkFocusChanged, DOMEvent : "blur", ignoreChildBlur : true});
            this.unbindViewEvent({view : this.latestVisitorInfo.focusedView, callback : this.checkFocusChanged, DOMEvent : "input"});
        }
        ShortcutPopupViewController.prototype.updateFocusedView.call(this, visitorInfo.focusedView);
        //this.bindViewEvent({view : visitorInfo.focusedView, callback : this.checkFocusChanged, DOMEvent : "blur", ignoreChildBlur : true});
        this.bindViewEvent({view : visitorInfo.focusedView, callback : this.checkFocusChanged, DOMEvent : "input"});

    };

    /**
     * This method's purpose is to check if the focus was taken from the popupView and to hide it if so.
     * To accomplish that, we assigned it to several events:
     * - blur on focused view - to identify clicks outside of the chat input.
     * - input on focused view - to identify mouse manipulations on the text while the popup is open
     * - mousedown on the popupView - this is a special case that was handled due to the fact that clicking on the popup triggers a blur on the focused view.
     *   this makes the popup to hide and to ignore the mouse click (to select a row for example).
     *   to overcome this we listen to this event and when triggered we check if the mouse was clicked on the popup view and if so when the blur event will arrive\
     *   (always after the click) we will ignore it to allow the popup to behave as should.
     *
     * @param e
     */

    PreDefinedShortcutPopup.prototype.checkFocusChanged = function (e) {
        if (this.mouseDownOnPopup) { // ignore the the blur event since it came after the mouse was down on the popup.
            this.mouseDownOnPopup = false;
            return;
        }
        if (e && lpUtils.isDescendant(this.latestVisitorInfo.targetView, e.relatedTarget || e.explicitOriginalTarget || e.srcElement)) { // check if the mouse click was on the popup
            this.shortcutsTable.focus();
            this.mouseDownOnPopup = true;
        } else {
            this.lpHide();
        }
    };

    PreDefinedShortcutPopup.prototype.lpShow = function (view, parentScope, animate) {
        view = view || this.view;
        ShortcutPopupViewController.prototype.lpShow.call(this, view, parentScope, animate);
        if (view === this.view) {
            this.shortcutsTable.selectRowByIndex(0, 0);
        }
    };

    PreDefinedShortcutPopup.prototype.lpHide = function (view, parentScope, animate) {
        if (this.visible) {
            ShortcutPopupViewController.prototype.lpHide.call(this, view, parentScope, animate);
            this.latestVisitorInfo.focusedView.focus();
            this.notifyHide.call(this.managerContext);
        }
    };

    PreDefinedShortcutPopup.prototype.getItemByIndex = function (index) {
        return this.shortcutsTable && this.shortcutsTable.modelData && this.shortcutsTable.modelData[0] && this.shortcutsTable.modelData[0][index];
    };

    return PreDefinedShortcutPopup;

});
